/**
 * BackToMenu — floating "return" tool present on every app page (except the
 * dashboard itself and public pages). One click goes back; long label goes
 * to the Agency Dashboard, the start-of-work hub.
 */
import { useLocation, useNavigate } from "react-router-dom";
import { ArrowLeft, LayoutDashboard } from "lucide-react";
import { useLang } from "../i18n/LangContext";

const HIDDEN_PREFIXES = [
  "/login", "/signup", "/landing", "/magic-login", "/impersonate",
  "/auth", "/blog", "/about", "/dashboard", "/trial-expired",
];

export default function BackToMenu() {
  const location = useLocation();
  const navigate = useNavigate();
  const { lang } = useLang();
  const isPt = lang === "pt";
  const path = location.pathname;
  if (path === "/" || HIDDEN_PREFIXES.some((p) => path.startsWith(p))) return null;

  return (
    <div
      className="fixed bottom-4 left-4 z-[60] flex items-center gap-1.5"
      data-testid="back-to-menu"
    >
      <button
        type="button"
        onClick={() => navigate(-1)}
        title={isPt ? "Voltar à página anterior" : "Go back"}
        data-testid="btm-back"
        className="w-9 h-9 rounded-full bg-[#1A1A2E] text-white/90 border border-white/15 shadow-lg hover:bg-[#C9A24E] hover:text-[#1A1A2E] flex items-center justify-center transition-colors"
      >
        <ArrowLeft className="w-4 h-4" />
      </button>
      <button
        type="button"
        onClick={() => navigate("/dashboard")}
        title={isPt ? "Ir para o Agency Dashboard" : "Go to Agency Dashboard"}
        data-testid="btm-dashboard"
        className="h-9 px-3 rounded-full bg-[#1A1A2E] text-white/90 border border-white/15 shadow-lg hover:bg-[#C9A24E] hover:text-[#1A1A2E] flex items-center gap-1.5 text-[11.5px] font-bold transition-colors"
      >
        <LayoutDashboard className="w-3.5 h-3.5" />
        {isPt ? "Menu" : "Menu"}
      </button>
    </div>
  );
}
